
import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

const EmptyDashboardState = () => {
  return (
    <Card>
      <CardContent className="p-6 flex flex-col items-center justify-center text-center py-10">
        <div className="rounded-full bg-primary/10 p-6 mb-4">
          <BookOpen className="h-12 w-12 text-primary" />
        </div>
        <h3 className="text-lg font-medium mb-2">You haven't enrolled in any courses yet</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          Browse our course catalog to find courses that match your interests and learning goals.
        </p>
        <Link to="/">
          <Button size="lg">
            Browse Courses
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};

export default EmptyDashboardState;
